import { Request } from 'commons/utils/request/request'
import { WriteHook, useMutationManager } from 'state-manager'
import { ManageDocumentFormType } from '~bank-documents/types/documentEdit'

type ManageDocumentRequest = ManageDocumentFormType & { id?: number }

const saveDocument = (document: ManageDocumentRequest) => Request.put(Request.urls.bank.document, document)
const createDocument = (document: ManageDocumentRequest) => Request.post(Request.urls.bank.document, document)

export const useSaveDocument: WriteHook<Partial<ManageDocumentRequest>, void> = (document) =>
  useMutationManager<ManageDocumentRequest, void>(saveDocument, document)

export const useCreateDocument: WriteHook<ManageDocumentRequest, ManageDocumentRequest> = (document) =>
  useMutationManager<ManageDocumentRequest, ManageDocumentRequest>(createDocument, document)
